import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { UNLISTED_PAGES } from '@/app/shells/cabinet/unlistedPages';
import type { NavItem } from '@/app/shells/cabinet/types/NavItem';
import { appShell } from '@/i18n/dictionaries/appShell';
import { useTranslation } from '@/i18n/useTranslation';

/**
 * `document.title` for a cabinet page: the sidebar entry the current path matches, then the zone
 * suffix — or the suffix alone for a path the sidebar does not list.
 */
export function useCabinetDocumentTitle(items: NavItem[]) {
  const { t, language } = useTranslation(appShell);
  const location = useLocation();

  // Separate from the focus-management effect in useCabinetDrawer (which must run only on
  // navigation, not on every language toggle) so switching RO/EN updates the title immediately.
  useEffect(() => {
    const match = [...items, ...UNLISTED_PAGES].find((i) => i.to === location.pathname);
    document.title = match ? `${t(match.label)} · ${t('pageTitleSuffix')}` : t('pageTitleSuffix');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname, language]);
}
